import { Link } from 'react-router';

import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import TruncatedTextWithTooltip from '#/modules/commonComponents/table/TruncatedTextWithTooltip';

function stopRowClick(event) {
  event.stopPropagation();
}

export function buildUserColumns({ canUpdate, canOpenAccess }) {
  return [
    {
      id: 'actions',
      header: '操作',
      size: 155,
      minSize: 150,
      enableSorting: false,
      enableResizing: false,
      meta: { enableColumnOrder: false, cellClassName: 'whitespace-nowrap' },
      cell: ({ row }) => (
        <div className="flex gap-2">
          <Button type="button" size="sm" variant="outline" asChild>
            <Link to={ROUTES.systemUserEdit(row.original.id)} onClick={stopRowClick}>
              {canUpdate ? '編輯' : '查看'}
            </Link>
          </Button>
          {canOpenAccess ? (
            <Button type="button" size="sm" variant="outline" asChild>
              <Link to={ROUTES.systemUserAccessFor(row.original.id)} onClick={stopRowClick}>
                存取設定
              </Link>
            </Button>
          ) : null}
        </div>
      ),
    },
    {
      header: '編號',
      accessorKey: 'accountNo',
      size: 100,
      meta: { cellClassName: 'font-mono text-xs' },
      cell: ({ row }) => row.original.accountNo || '—',
    },
    {
      header: '帳號',
      accessorKey: 'account',
      size: 110,
      meta: { cellClassName: 'font-mono text-xs' },
      cell: ({ row }) => row.original.account || '—',
    },
    {
      header: '姓名',
      id: 'name',
      accessorFn: (row) => row.name || row.chnName,
      size: 100,
      cell: ({ getValue }) => getValue() || '—',
    },
    {
      header: '工作信箱',
      accessorKey: 'workEmail',
      size: 220,
      enableSorting: false,
      cell: ({ row }) => <TruncatedTextWithTooltip text={row.original.workEmail || '—'} />,
    },
    {
      header: '狀態',
      accessorKey: 'status',
      size: 90,
    },
    {
      header: '最近登入',
      accessorKey: 'lastLoginAt',
      size: 170,
      enableSorting: false,
      meta: { cellClassName: 'text-muted-foreground' },
      cell: ({ row }) => row.original.lastLoginAt?.slice(0, 16) || '—',
    },
  ];
}
